export default "__VITE_ASSET__cbe1349f__"